module.exports = __webpack_public_path__ + "static/media/5-4.2f3df8a1.mp3";